import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import logo from '../../assets/psha-logo.png';
import { PHONE_NUMBER, PHONE_NUMBER_LINK } from '../../data/contact';

const navItems = [
  { label: 'Home', to: '/' },
  { label: 'Service', to: '/service' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

const SiteHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="site-header">
      <div className="container site-header-inner">
        <Link to="/" className="site-brand">
          <img
            src={logo}
            alt="Preferred Service Heating and Air logo"
            className="site-brand-logo"
            width="240"
            height="200"
          />
          <div className="site-brand-copy">
            <span className="site-brand-name">Preferred Services Heating & Air</span>
            <span className="site-brand-tag">Salt Lake County Home Comfort</span>
          </div>
        </Link>
        <button
          type="button"
          className="site-menu-toggle"
          aria-expanded={isMenuOpen}
          aria-controls="site-nav"
          aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>
        <nav
          id="site-nav"
          className={`site-nav${isMenuOpen ? ' is-open' : ''}`}
          aria-label="Main navigation"
        >
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `site-nav-link${isActive ? ' is-active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <a href={PHONE_NUMBER_LINK} className="site-phone">
          {PHONE_NUMBER}
        </a>
      </div>
    </header>
  );
};

export default SiteHeader;
